import {Icon} from '../Icon';
import {useState} from 'react';
import {useDetectClickOutside} from 'react-detect-click-outside';

function ProfileMenu() {

    const [open, setOpen] = useState(false)

    const menu = [
        {
            title: 'Account'
        },
        {
            title: 'Profile'
        },
        {
            title: 'Logout'
        }
    ]

    const ref = useDetectClickOutside({
        onTriggered: () => {
            setOpen(false)
        }
    });

	return (
        <div ref={ref} className="relative">
            <button
                onClick={() => setOpen(!open)}
                className={`h-8 gap-x-2 flex items-center p-[2px] pr-2 box-border rounded-2xl ${open ? 'bg-gray-810' : 'bg-black bg-opacity-70'}`}>
                <img src="https://i.scdn.co/image/ab6775700000ee856fca122911ed9eec4ce60c1e"
                     className="h-full rounded-full"/>
                <span className="text-sm font-semibold">Tayfun Erbilen</span>
                <Icon src="dirDown" size={16} className={`transform block ${open ? 'rotate-180' : ''}`} />
            </button>
            <nav className={`absolute w-48 rounded right-0 ${open ? 'translate-y-2 opacity-100' : 'opacity-0'} transition-all top-full absolute z-10 bg-gray-810 shadow-spotify-shadow text-black`}>
                <ul className="p-1 border-b border-white border-opacity-5 last:border-none">
                    {menu.map((item, index) => (
                        <li key={index}>
                            <button
                                className="h-10 text-left flex w-full rounded-sm items-center justify-start text-white text-opacity-80 px-4 hover:bg-white hover:bg-opacity-10" style={{fontSize: '13px'}}>
                                {item.title}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
	)
}

export default ProfileMenu